// // JavaScript Document

// function isDevice() {

//     return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());

// }
 
// function initZoom(selector, width, height) {

//     $(selector).each(function() {

//         var $this = $(this);

//         $.removeData($this, 'elevateZoom');

//         $this.siblings('.zoomContainer').remove();

//         $this.siblings('.zoomWindowContainer').remove();

//         $this.elevateZoom({

//             responsive: true,

//             tint: true,

//             tintColour: '#FFF',

//             tintOpacity: 0.5,

//             easing: true,

//             borderSize: 0,

//             lensSize: 100,

//             constrainType: "height",

//             loadingIcon: "images/loading.GIF",

//             containLensZoom: false,

//             zoomWindowPosition: 1,

//             zoomWindowOffetx: 20,

//             zoomWindowWidth: width,

//             zoomWindowHeight: height,

//             gallery: 'gallery_pdp',

//             galleryActiveClass: "active",

//             zoomWindowFadeIn: 500,

//             zoomWindowFadeOut: 500,

//             lensFadeIn: 500,

//             lensFadeOut: 500,

//             cursor: "images/zoom-out.png",

//         });

//     });

// }
 
// $(document).ready(function() {
 
//     /* image gallery carousel */

//     $("body").delegate(".zoomContainer", "mouseenter", function() {

//         $(".hint-pdp-img").text("Click to open expanded view");

//     });

//     $("body").delegate(".zoomContainer", "mouseleave", function() {

//         $(".hint-pdp-img").text("Roll over the image to zoom in");

//     });
 
//     /* init vertical carousel if thumb image length greater that 4 */

//     if ($("#gallery_pdp a").length > 4) {

//         $("#gallery_pdp a").css("margin", "0");

//         $("#gallery_pdp").rcarousel({

//             orientation: "vertical",

//             visible: 4,

//             width: 105,

//             height: 70,

//             margin: 5,

//             step: 1,

//             speed: 500,

//         });

//         $("#ui-carousel-prev").show();

//         $("#ui-carousel-next").show();

//     }
 
//     /* Init Product zoom */

//     initZoom(".image-magnify-lightbox", 500, 475);
 
//     $(".zoomContainer").width($("#zoom_10").width());
 
//     /* enlarge option inside fancy along with carousel */

//     $(".image-magnify-lightbox").bind("click", function(e) {

//         var $this = $(this);

//       //&& !isDevice()

//         if (!$.browser.mobile && ($(window).width() > 768) ) {

//             var ez = $this.data('elevateZoom');

//             $.fancybox(ez.getGalleryList(), {

//                 wrapCSS: 'pdp_enl_opt',

//                 autoSize: true,

//                 autoCenter: true,

//                 scrolling: 'no',

//                 openEffect: 'fade',

//                 nextEffect: 'fade',

//                 prevEffect: 'fade',

//                 openSpeed: 300,

//                 closeSpeed: 400,

//                 afterLoad: function() {

//                     $(".enl_butt").clone().appendTo(".fancybox-inner");

//                     $(".mega_enl").clone().appendTo(".fancybox-inner");

//                 },

//                 beforeLoad: function() {

//                     $(".fancybox-inner .enl_butt").remove();

//                     $(".fancybox-inner .mega_enl").remove();

//                 },

//                 helpers: {

//                     overlay: {

//                         css: {

//                             'background': 'rgba(255, 0, 0, 0.5)'

//                         }

//                     }

//                 },

//             });

//             return false;

//         }

//     });
 
//     $("body").delegate(".enl_fclose", "click", function() {

//         $.fancybox.close();

//     });
 
//     $("body").delegate(".enl_fleft", "click", function() {

//         $.fancybox.prev();

//     });
 
//     $("body").delegate(".enl_fright", "click", function() {

//         $.fancybox.next();

//     });
 
//     /* Init Mega enlarge option */

//     $("body").delegate(".fancybox-image", "click", function() {

//         $(".fancybox-inner .mega_enl ").show();

//         $(".fancybox-image").clone().appendTo(".mega_enl");

//         $(".mega_enl .fancybox-image").attr("id", "panic");

//         $(".mega_enl .fancybox-image").removeClass();

//         $(".mega_enl img").imagePanning();

//     });
 
//     $("body").delegate(".fancybox-inner .mega_enl", "click", function() {

//         $(this).html("");

//         $(this).hide();

//     });
 
//     /* Initialize zoom on page load */

//     $(window).on('load', function() {

//         initZoom(".image-magnify-lightbox", 500, 475);

//     });
 
// });
 
// //$(window).resize(function() {

//     var docWidth = $(document).width();

//     if (docWidth > 769) {

//         initZoom(".image-magnify-lightbox", 500, 475);

//     } else {

//         $(".image-magnify-lightbox").each(function() {

//             var $this = $(this);

//             $.removeData($this, 'elevateZoom');

//             $this.siblings('.zoomContainer').remove();

//             $this.siblings('.zoomWindowContainer').remove();

//             $this.elevateZoom({

//                 responsive: true,

//                 tint: false,

//                 tintColour: '#FFF',

//                 tintOpacity: 0.5,

//                 easing: true,

//                 borderSize: 0,

//                 loadingIcon: "../images/loading.GIF",

//                 zoomWindowPosition: "productInfoContainer",

//                 zoomWindowWidth: 330,

//                 gallery: 'gallery_pdp',

//                 galleryActiveClass: "active",

//                 zoomWindowFadeIn: 500,

//                 zoomWindowFadeOut: 500,

//                 lensFadeIn: 500,

//                 lensFadeOut: 500,

//                 cursor: "images/zoom-out.png",

//             });

//         });

//     }

// //});

 
function isDevice() {
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
}

function initZoom(selector, width, height) {
    $(selector).each(function() {
        var $this = $(this);

        // Reset the zoom data
        $.removeData($this, 'elevateZoom');
        $this.siblings('.zoomContainer').remove();
        $this.siblings('.zoomWindowContainer').remove();

        // Initialize zoom with both horizontal and vertical movements
        $this.elevateZoom({
            responsive: true,
            tint: true,
            tintColour: '#FFF',
            tintOpacity: 0.5,
            easing: true,
            borderSize: 0,
            lensSize: 100,
            constrainType: null,  // Allow both vertical and horizontal movement
            containLensZoom: false,
            loadingIcon: "images/loading.GIF",
            zoomWindowPosition: 1,
            zoomWindowOffetx: 20,
            zoomWindowWidth: width,
            zoomWindowHeight: height,
            gallery: 'gallery_pdp',
            galleryActiveClass: "active",
            zoomWindowFadeIn: 500,
            zoomWindowFadeOut: 500,
            lensFadeIn: 500,
            lensFadeOut: 500,
            cursor: "images/zoom-out.png"
        });
    });
}

$(document).ready(function() {
    /* image gallery carousel */
    $("body").delegate(".zoomContainer", "mouseenter", function() {
        $(".hint-pdp-img").text("Click to open expanded view");
    });

    $("body").delegate(".zoomContainer", "mouseleave", function() {
        $(".hint-pdp-img").text("Roll over the image to zoom in");
    });

    /* init vertical carousel if thumb image length greater that 4 */
    if ($("#gallery_pdp a").length > 4) {
        $("#gallery_pdp a").css("margin", "0");
        $("#gallery_pdp").rcarousel({
            orientation: "vertical",
            visible: 4,
            width: 105,
            height: 70,
            margin: 5,
            step: 1,
            speed: 500,
        });

        $("#ui-carousel-prev").show();
        $("#ui-carousel-next").show();
    }

    /* Init Product zoom */
    initZoom(".image-magnify-lightbox", 350, 300);

    $(".zoomContainer").width($("#zoom_10").width());

    /* enlarge option inside fancy along with carousel */
    $(".image-magnify-lightbox").bind("click", function(e) {
        var $this = $(this);

        if (!$.browser.mobile && ($(window).width() > 768)) {
            var ez = $this.data('elevateZoom');

            $.fancybox(ez.getGalleryList(), {
                wrapCSS: 'pdp_enl_opt',
                autoSize: true,
                autoCenter: true,
                scrolling: 'no',
                openEffect: 'fade',
                nextEffect: 'fade',
                prevEffect: 'fade',
                openSpeed: 300,
                closeSpeed: 400,
                afterLoad: function() {
                    $(".enl_butt").clone().appendTo(".fancybox-inner");
                    $(".mega_enl").clone().appendTo(".fancybox-inner");
                },
                beforeLoad: function() {
                    $(".fancybox-inner .enl_butt").remove();
                    $(".fancybox-inner .mega_enl").remove();
                },
                helpers: {
                    overlay: {
                        css: {
                            'background': 'rgba(255, 0, 0, 0.5)'
                        }
                    }
                },
            });

            return false;
        }
    });

    $("body").delegate(".enl_fclose", "click", function() {
        $.fancybox.close();
    });

    $("body").delegate(".enl_fleft", "click", function() {
        $.fancybox.prev();
    });

    $("body").delegate(".enl_fright", "click", function() {
        $.fancybox.next();
    });

    /* Init Mega enlarge option */
    $("body").delegate(".fancybox-image", "click", function() {
        $(".fancybox-inner .mega_enl ").show();
        $(".fancybox-image").clone().appendTo(".mega_enl");
        $(".mega_enl .fancybox-image").attr("id", "panic");
        $(".mega_enl .fancybox-image").removeClass();
        $(".mega_enl img").imagePanning();
    });

    $("body").delegate(".fancybox-inner .mega_enl", "click", function() {
        $(this).html("");
        $(this).hide();
    });

    /* Initialize zoom on page load */
    $(window).on('load', function() {
        initZoom(".image-magnify-lightbox", 350, 300);
    });

    $(window).resize(function() {
        var docWidth = $(document).width();

        if (docWidth > 769) {
            initZoom(".image-magnify-lightbox", 350, 300);
        } else {
            $(".image-magnify-lightbox").each(function() {
                var $this = $(this);

                $.removeData($this, 'elevateZoom');
                $this.siblings('.zoomContainer').remove();
                $this.siblings('.zoomWindowContainer').remove();

                $this.elevateZoom({
                    responsive: true,
                    tint: false,
                    tintColour: '#FFF',
                    tintOpacity: 0.5,
                    easing: true,
                    borderSize: 0,
                    loadingIcon: "../images/loading.GIF",
                    zoomWindowPosition: "productInfoContainer",
                    zoomWindowWidth: 330,
                    gallery: 'gallery_pdp',
                    galleryActiveClass: "active",
                    zoomWindowFadeIn: 500,
                    zoomWindowFadeOut: 500,
                    lensFadeIn: 500,
                    lensFadeOut: 500,
                    cursor: "images/zoom-out.png"
                });
            });
        }
    });
});
